import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { TopbarComponent } from './topbar/topbar.component';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from './footer/footer.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TourNgBootstrapModule } from 'ngx-ui-tour-ng-bootstrap';
import { PreloaderComponent } from '../shared/components/preloader/preloader.component';
import { AvatarComponent } from '../shared/components/avatar/avatar.component';

@NgModule({
  declarations: [
    LayoutComponent,
    TopbarComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgClickOutsideDirective,
    NgbDropdownModule,
    TourNgBootstrapModule,
    PreloaderComponent,
    AvatarComponent,
  ]
})
export class LayoutModule { }
